import React from "react";
import { DisplayLanguage, useLanguage } from "../contexts/LanguageContext";

interface LanguageSelectorProps {
  variant?: "light" | "dark";
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  variant = "light",
}) => {
  const { language, setLanguage, t } = useLanguage();
  const isDark = variant === "dark";

  return (
    <label
      className={`flex items-center gap-2 text-sm font-medium ${
        isDark ? "text-white" : "text-gray-700"
      }`}
    >
      <span className="sr-only">{t("common.language")}</span>
      <select
        value={language}
        onChange={(event) => setLanguage(event.target.value as DisplayLanguage)}
        aria-label={t("common.language")}
        className={`rounded-md border px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 ${
          isDark
            ? "border-white/40 bg-white/15 text-white focus:ring-white [&>option]:text-gray-900"
            : "border-gray-300 bg-white text-gray-800 focus:ring-indigo-500"
        }`}
      >
        <option value="en">{t("common.english")}</option>
        <option value="zh">{t("common.chinese")}</option>
      </select>
    </label>
  );
};

export default LanguageSelector;
